import React from 'react'

type Props = {
  authorName: string
  reviewDate: string
  locale?: string
  avatarWrapperClassName?: string
  avatarLabelClassName?: string
  titleClassName?: string
  dateClassName?: string
}

const ReviewAuthor = ({
  authorName,
  reviewDate,
  locale = 'fr-FR',
  avatarWrapperClassName = 'symbol symbol-circle symbol-50px me-4',
  avatarLabelClassName = 'symbol-label fs-3 fw-bolder bg-light-primary text-primary',
  titleClassName = 'text-gray-900 fw-bolder fs-4',
  dateClassName = 'text-muted fw-semibold fs-7',
}: Props) => {
  const formattedDate = new Date(reviewDate).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <div className='d-flex align-items-center'>
      <div className={avatarWrapperClassName}>
        <div className={avatarLabelClassName}>{authorName.charAt(0)}</div>
      </div>
      <div>
        <div className={titleClassName}>{authorName}</div>
        <div className={dateClassName}>{formattedDate}</div>
      </div>
    </div>
  )
}

export {ReviewAuthor}
